import React from 'react';
import MuiButton from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import * as S from './styles';
import { withStyles } from '@material-ui/core/styles';

export type CallCenterRedirectModalProps = {
    open: boolean
    onClose: () => void
};

const Button = withStyles({
    root: {
        boxShadow: 'none',
        textTransform: 'none',
        fontSize: 16,
        fontWeight: 600,
        marginBottom: 16,
        fontFamily: [
            'Monstserrat',
            'sans-serif'
        ].join(',')
    }
})(MuiButton);

export function CallCenterRedirectModal(props: Readonly<CallCenterRedirectModalProps>) {
    return <Dialog
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <div>

        </div>
        <S.Header>
            <IconButton aria-label="close" onClick={props.onClose}>
                <CloseIcon />
            </IconButton>
        </S.Header>
        <S.Container>
            <S.Title>Agende suas consultas</S.Title>
            <div style={{ width: '104px' }}>
                <svg id="Icon_-_Check" data-name="Icon - Check" xmlns="http://www.w3.org/2000/svg" width="104" height="104" viewBox="0 0 104 104">
                    <rect id="Retângulo_4172" data-name="Retângulo 4172" width="104" height="104" fill="none" />
                    <g id="check-circle" transform="translate(17.333 17.333)">
                        <path id="Caminho_25272" data-name="Caminho 25272" d="M71.333,33.493v3.189A34.667,34.667,0,1,1,50.776,5" transform="translate(-2 -1.994)" fill="none" stroke="#004f92" strokeLinecap="round" strokeLinejoin="round" strokeWidth="6" />
                        <path id="Caminho_25273" data-name="Caminho 25273" d="M54.067,4,19.4,38.7,9,28.3" transform="translate(15.267 2.955)" fill="none" stroke="#004f92" strokeLinecap="round" strokeLinejoin="round" strokeWidth="6" />
                    </g>
                </svg>
            </div>
            <DialogContent>
                <S.Text>
                    Para agendar sua consulta, <b>ligue</b> para <b>(11) 2151-6381, (11) 2151-0408</b> ou entre em contato com a nossa equipe pelo <b>WhatsApp: (11) 3620-2550.</b>
                </S.Text>
            </DialogContent>
            <DialogActions>
                {/* @ts-expect-error */}
                <Button onClick={props.onClose} color="primary">
                    Voltar para o início
                </Button>
            </DialogActions>
        </S.Container>
    </Dialog>;
}
